import { Step } from '../types';
import { LimitedCurrencyAmount } from '@lx/currency/shared/model/currency.model';
import { OnlineCourseDetails } from '../types';
import { StudentDetails } from '@lx/quote-tool/shared/types';

/**
 * State of the Online Quote Tool
 */
export interface OnlineQuoteToolState {
  currentStep?: Step;
  residenceCountryCode?: string;
  phoneCode?: string;
  currency?: string;
  selectedSchool?: string;
  selectedCourse?: OnlineCourseDetails;
  selectedDuration?: number;
  selectedStartDate?: string;
  selectedEndDate?: string;
  studentDetails?: StudentDetails;
  quoteId?: string;
  grandTotal?: LimitedCurrencyAmount[];
  /**
   * Counter for analytics tracking (quote number).
   * This must be incremented when starting a new quote.
   */
  requestedQuotes?: number;
}
